import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './fx-calculator.component.scss';
import axios from 'axios';
var FxCalculator = /** @class */ (function (_super) {
    tslib_1.__extends(FxCalculator, _super);
    function FxCalculator(element) {
        return _super.call(this, element) || this;
    }
    FxCalculator.prototype.init = function () {
        this.selectCurrency = Array.from(this.element.querySelectorAll('.fx-calculator__select--value'));
        this.switcher = this.element.querySelector('.fx-calculator__switch');
        this.containerBuyingValue = this.element.querySelector('.js-buying-amount');
        this.containerBuyingCurrency = this.element.querySelector('.js-buying-currency');
        this.containerSellingValue = this.element.querySelector('.js-selling-amount');
        this.containerSellingCurrency = this.element.querySelector('.js-selling-currency');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.inputCurrency = this.element.querySelector('.fx-calculator__input--value__icon');
        this.valueCurrency = 'USD';
        this.valueSwitcher = false;
        this.apiFeed();
        this.changeText();
    };
    FxCalculator.prototype.bindEvents = function () {
        var _this = this;
        if (this.selectCurrency) {
            this.selectCurrency.map(function (item) { return item.addEventListener('click', function (event) {
                _this.removeActive();
                var parentContainer = item.closest('.fx-calculator__select');
                if (parentContainer.classList.contains('')) {
                    parentContainer.classList.remove('active');
                }
                else {
                    parentContainer.classList.add('active');
                }
            }); });
        }
        if (this.switcher) {
            this.switcher.addEventListener('click', function (event) {
                _this.removeActive();
                _this.valueSwitcher = _this.valueSwitcher ? false : true;
                if (_this.valueSwitcher) {
                    _this.inputCurrency.innerHTML = 'AOA';
                }
                else {
                    _this.inputCurrency.innerHTML = _this.valueCurrency;
                }
                _this.selectBuyCurrency.innerHTML = '';
                _this.selectWithCurrency.innerHTML = '';
                _this.setupLayoutBuy(_this.valueSwitcher);
                _this.setupLayoutWith(_this.valueSwitcher);
                _this.setupValueBuy(_this.valueSwitcher);
                _this.setupValueWith(_this.valueSwitcher);
            });
        }
        if (this.buttonCalculate) {
            this.buttonCalculate.addEventListener('click', function (event) {
                _this.calculate();
            });
        }
        if (this.buttonReset) {
            this.buttonReset.addEventListener('click', function (event) {
                _this.valueCurrency = 'USD';
                _this.valueSwitcher = false;
                _this.inputCurrency.innerHTML = _this.valueCurrency;
                _this.setupLayoutBuy(false);
                _this.setupLayoutWith(false);
                _this.setupValueBuy(false);
                _this.setupValueWith(false);
            });
        }
        this.inputAmount = this.element.querySelector('.fx-calculator__input--value');
        if (this.inputAmount) {
            this.inputAmount.addEventListener('input', function (event) {
                var formattedValue = event.target.value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                event.target.value = formattedValue.trim();
            });
        }
    };
    FxCalculator.prototype.apiFeed = function () {
        var _this = this;
        // let url = "/file_source/Market-Data-Files/FXRates/AngolaFXRates.json";
        // let url: any = "https://sb.imgraham.co.za/api/angola/rates";
        var url = "/file_source/Market-Data-Files/FXRates/AngolaFXRates.json";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        axios.get(url).then(function (response) {
            var json = response.data;
            _this.json = json;
            _this.setupLayoutBuy(_this.valueSwitcher);
            _this.setupLayoutWith(_this.valueSwitcher);
            _this.setupValueBuy(_this.valueSwitcher);
            _this.setupValueWith(_this.valueSwitcher);
            _this.calculate();
        }).catch(function (error) {
            console.log(error);
        });
    };
    FxCalculator.prototype.calculate = function () {
        var _this = this;
        var value = 0;
        var buyAmount = this.element.querySelector('.js-input');
        var formattedBuyAmount = '';
        if (buyAmount.value) {
            formattedBuyAmount = buyAmount.value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        if (this.valueSwitcher) {
            this.json.forEach(function (object) {
                if (object.currency === _this.valueCurrency) {
                    value = object.bid;
                }
            });
            this.containerBuyingValue.innerHTML = formattedBuyAmount;
            var calculation = parseFloat(buyAmount.value) / value;
            if (calculation >= 1) {
                calculation = this.round(calculation, 2).toLocaleString();
            }
            else {
                calculation = this.round(calculation, 4).toLocaleString();
            }
            this.containerSellingValue.innerHTML = calculation.replace(/,/g, ' '); // Format with space separators
            this.containerBuyingCurrency.innerHTML = 'AOA';
            this.containerSellingCurrency.innerHTML = this.valueCurrency;
        }
        else {
            this.json.forEach(function (object) {
                if (object.currency === _this.valueCurrency) {
                    value = object._offer;
                }
            });
            this.containerBuyingValue.innerHTML = formattedBuyAmount;
            var calculation = parseFloat(buyAmount.value) * value;
            if (calculation >= 1) {
                calculation = this.round(calculation, 2).toLocaleString();
            }
            else {
                calculation = this.round(calculation, 4).toLocaleString();
            }
            this.containerSellingValue.innerHTML = calculation.replace(/,/g, ' ');
            this.containerBuyingCurrency.innerHTML = this.valueCurrency;
            this.containerSellingCurrency.innerHTML = 'AOA';
        }
    };
    FxCalculator.prototype.setupLayoutBuy = function (switched) {
        var _this = this;
        if (switched === void 0) { switched = false; }
        this.selectBuyCurrency = this.element.querySelector('.js-primary-list');
        this.selectBuyCurrency.innerHTML = '';
        var currencies = ['GBP', 'USD', 'ZAR', 'EUR'];
        if (switched) {
            var item = "<div class=\"fx-calculator__select--list__item js-currency-selector-with\">\n\t\t\t\t<div class=\"fx-calculator__select--list__item--icon\">\n\t\t\t\t\t<img src=\"/file_source/assets/icons/flag-angola.svg\" alt=\"\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"fx-calculator__select--list__item--text\">AOA - Angolan Kwanza</div>\n\t\t\t</div>";
            var docfragment = document.createDocumentFragment();
            docfragment.appendChild(document.createRange().createContextualFragment(item));
            this.selectBuyCurrency.appendChild(docfragment);
        }
        else {
            this.json.forEach(function (object) {
                if (currencies.includes(object.currency)) {
                    var name_1 = 'USD - United States Dollar';
                    var icon = '<img src="/file_source/assets/icons/flag-united-states.svg" alt="">';
                    if (object.currency === 'USD') {
                        name_1 = 'USD - United States Dollar';
                        icon = '<img src="/file_source/assets/icons/flag-united-states.svg" alt="">';
                    }
                    if (object.currency === 'EUR') {
                        name_1 = 'EUR - EURO';
                        icon = '<img src="/file_source/assets/icons/flag-euro.svg" alt="">';
                    }
                    if (object.currency === 'GBP') {
                        name_1 = 'GBP - British Pound Sterling';
                        icon = '<img src="/file_source/assets/icons/flag-united-kingdom.svg" alt="">';
                    }
                    if (object.currency === 'ZAR') {
                        name_1 = 'ZAR - South African Rand';
                        icon = '<img src="/file_source/assets/icons/flag-south-africa.svg" alt="">';
                    }
                    var item = "<div class=\"fx-calculator__select--list__item js-currency-selector-buy\" data-currency=\"" + object.currency + "\">\n\t\t\t\t\t\t<div class=\"fx-calculator__select--list__item--icon\">\n\t\t\t\t\t\t\t" + icon + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"fx-calculator__select--list__item--text\">" + name_1 + "</div>\n\t\t\t\t\t</div>";
                    var docfragment = document.createDocumentFragment();
                    docfragment.appendChild(document.createRange().createContextualFragment(item));
                    _this.selectBuyCurrency.appendChild(docfragment);
                }
            });
        }
        this.listSetup();
    };
    FxCalculator.prototype.setupLayoutWith = function (switched) {
        var _this = this;
        if (switched === void 0) { switched = false; }
        this.selectWithCurrency = this.element.querySelector('.js-secondary-list');
        this.selectWithCurrency.innerHTML = '';
        var currencies = ['GBP', 'USD', 'ZAR', 'EUR'];
        if (switched) {
            this.json.forEach(function (object) {
                if (currencies.includes(object.currency)) {
                    var name_2 = 'USD - United States Dollar';
                    var icon = '<img src="/file_source/assets/icons/flag-united-states.svg" alt="">';
                    if (object.currency === 'USD') {
                        name_2 = 'USD - United States Dollar';
                        icon = '<img src="/file_source/assets/icons/flag-united-states.svg" alt="">';
                    }
                    if (object.currency === 'EUR') {
                        name_2 = 'EUR - EURO';
                        icon = '<img src="/file_source/assets/icons/flag-euro.svg" alt="">';
                    }
                    if (object.currency === 'GBP') {
                        name_2 = 'GBP - British Pound Sterling';
                        icon = '<img src="/file_source/assets/icons/flag-united-kingdom.svg" alt="">';
                    }
                    if (object.currency === 'ZAR') {
                        name_2 = 'ZAR - South African Rand';
                        icon = '<img src="/file_source/assets/icons/flag-south-africa.svg" alt="">';
                    }
                    var item = "<div class=\"fx-calculator__select--list__item js-currency-selector-buy\" data-currency=\"" + object.currency + "\">\n\t\t\t\t\t\t<div class=\"fx-calculator__select--list__item--icon\">\n\t\t\t\t\t\t\t" + icon + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"fx-calculator__select--list__item--text\">" + name_2 + "</div>\n\t\t\t\t\t</div>";
                    var docfragment = document.createDocumentFragment();
                    docfragment.appendChild(document.createRange().createContextualFragment(item));
                    _this.selectWithCurrency.appendChild(docfragment);
                }
            });
        }
        else {
            var item = "<div class=\"fx-calculator__select--list__item js-currency-selector-with\">\n\t\t\t\t<div class=\"fx-calculator__select--list__item--icon\">\n\t\t\t\t\t<img src=\"/file_source/assets/icons/flag-angola.svg\" alt=\"\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"fx-calculator__select--list__item--text\">AOA - Angolan Kwanza</div>\n\t\t\t</div>";
            var docfragment = document.createDocumentFragment();
            docfragment.appendChild(document.createRange().createContextualFragment(item));
            this.selectWithCurrency.appendChild(docfragment);
        }
        this.listSetup();
    };
    FxCalculator.prototype.setupValueBuy = function (switched) {
        var _this = this;
        if (switched === void 0) { switched = false; }
        var selectedIcon = '';
        var selectedText = '';
        this.selectBuyCurrencyValue = this.element.querySelector('.js-primary-value');
        if (switched) {
            selectedIcon = '<img src="/file_source/assets/icons/flag-angola.svg" alt="">';
            selectedText = 'AOA - Angolan Kwanza';
        }
        else {
            this.json.forEach(function (object) {
                if (object.currency === _this.valueCurrency) {
                    var name_3 = 'USD - United States Dollar';
                    var icon = '<img src="/file_source/assets/icons/flag-united-states.svg" alt="">';
                    if (object.currency === 'USD') {
                        name_3 = 'USD - United States Dollar';
                        icon = '<img src="/file_source/assets/icons/flag-united-states.svg" alt="">';
                    }
                    if (object.currency === 'EUR') {
                        name_3 = 'EUR - EURO';
                        icon = '<img src="/file_source/assets/icons/flag-euro.svg" alt="">';
                    }
                    if (object.currency === 'GBP') {
                        name_3 = 'GBP - British Pound Sterling';
                        icon = '<img src="/file_source/assets/icons/flag-united-kingdom.svg" alt="">';
                    }
                    if (object.currency === 'ZAR') {
                        name_3 = 'ZAR - South African Rand';
                        icon = '<img src="/file_source/assets/icons/flag-south-africa.svg" alt="">';
                    }
                    selectedIcon = icon;
                    selectedText = name_3;
                }
            });
        }
        var valueIcon = this.selectBuyCurrencyValue.querySelector('.fx-calculator__select--value__icon');
        var valueText = this.selectBuyCurrencyValue.querySelector('.fx-calculator__select--value__text');
        valueIcon.innerHTML = selectedIcon;
        valueText.innerHTML = selectedText;
    };
    FxCalculator.prototype.setupValueWith = function (switched) {
        var _this = this;
        if (switched === void 0) { switched = false; }
        var selectedIcon = '';
        var selectedText = '';
        this.selectWithCurrencyValue = this.element.querySelector('.js-secondary-value');
        if (switched) {
            this.json.forEach(function (object) {
                if (object.currency === _this.valueCurrency) {
                    var name_4 = 'USD - United States Dollar';
                    var icon = '<img src="/file_source/assets/icons/flag-united-states.svg" alt="">';
                    if (object.currency === 'USD') {
                        name_4 = 'USD - United States Dollar';
                        icon = '<img src="/file_source/assets/icons/flag-united-states.svg" alt="">';
                    }
                    if (object.currency === 'EUR') {
                        name_4 = 'EUR - EURO';
                        icon = '<img src="/file_source/assets/icons/flag-euro.svg" alt="">';
                    }
                    if (object.currency === 'GBP') {
                        name_4 = 'GBP - British Pound Sterling';
                        icon = '<img src="/file_source/assets/icons/flag-united-kingdom.svg" alt="">';
                    }
                    if (object.currency === 'ZAR') {
                        name_4 = 'ZAR - South African Rand';
                        icon = '<img src="/file_source/assets/icons/flag-south-africa.svg" alt="">';
                    }
                    selectedIcon = icon;
                    selectedText = name_4;
                }
            });
        }
        else {
            selectedIcon = '<img src="/file_source/assets/icons/flag-angola.svg" alt="">';
            selectedText = 'AOA - Angolan Kwanza';
        }
        var valueIcon = this.selectWithCurrencyValue.querySelector('.fx-calculator__select--value__icon');
        var valueText = this.selectWithCurrencyValue.querySelector('.fx-calculator__select--value__text');
        valueIcon.innerHTML = selectedIcon;
        valueText.innerHTML = selectedText;
    };
    FxCalculator.prototype.listSetup = function () {
        var _this = this;
        var selectionBuy = Array.from(this.element.querySelectorAll('.js-currency-selector-buy'));
        var selectionWith = Array.from(this.element.querySelectorAll('.js-currency-selector-with'));
        selectionBuy.map(function (item) { return item.addEventListener('click', function (event) {
            _this.valueCurrency = item.getAttribute('data-currency');
            if (_this.valueSwitcher) {
                _this.inputCurrency.innerHTML = 'AOA';
            }
            else {
                _this.inputCurrency.innerHTML = _this.valueCurrency;
            }
            _this.setupLayoutBuy(_this.valueSwitcher);
            _this.setupLayoutWith(_this.valueSwitcher);
            _this.setupValueBuy(_this.valueSwitcher);
            _this.setupValueWith(_this.valueSwitcher);
            _this.removeActive();
        }); });
        selectionWith.map(function (item) { return item.addEventListener('click', function (event) {
            _this.removeActive();
        }); });
    };
    FxCalculator.prototype.removeActive = function () {
        var allParents = Array.from(document.querySelectorAll('.fx-calculator__select'));
        allParents.forEach(function (element) {
            element.classList.remove('active');
        });
    };
    FxCalculator.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    FxCalculator.prototype.changeText = function () {
        if (document.querySelector('html')) {
            var documentHtml = document.querySelector('html');
            if (documentHtml.getAttribute('lang')) {
                var documentLang = documentHtml.getAttribute('lang');
                if (documentLang === 'pt') {
                    var dataPttHeading = this.element.getAttribute('data-pt-heading');
                    var dataPttBuy = this.element.getAttribute('data-pt-buy');
                    var dataPttWith = this.element.getAttribute('data-pt-with');
                    var dataPttAmount = this.element.getAttribute('data-pt-amount');
                    var dataPttCalculate = this.element.getAttribute('data-pt-calculate');
                    var dataPttReset = this.element.getAttribute('data-pt-reset');
                    var dataPttTobuy = this.element.getAttribute('data-pt-tobuy');
                    var dataPttSell = this.element.getAttribute('data-pt-sell');
                    var dataPttInvalid = this.element.getAttribute('data-pt-invalid');
                    var title = this.element.querySelector('.calculator-form__title');
                    var labelBuy = this.element.querySelector('label[for=buy_currency]');
                    var labelWith = this.element.querySelector('label[for=sell_currency]');
                    var labelBuyAmount = this.element.querySelector('label[for=buy_amount]');
                    var calculate = this.element.querySelector('.js-calculator-calculate');
                    var reset = this.element.querySelector('.js-calculator-reset');
                    var resetLinkText = reset.querySelector('.link__text');
                    var textBuy = this.element.querySelector('.js-heading-buy');
                    var textSell = this.element.querySelector('.js-heading-sell');
                    title.innerHTML = dataPttHeading;
                    labelBuy.innerHTML = dataPttBuy;
                    labelWith.innerHTML = dataPttWith;
                    labelBuyAmount.innerHTML = dataPttAmount;
                    calculate.innerHTML = dataPttCalculate;
                    resetLinkText.innerHTML = dataPttReset;
                    textBuy.innerHTML = '';
                    textSell.innerHTML = dataPttSell;
                }
            }
        }
    };
    return FxCalculator;
}(Base));
export { FxCalculator };



//////////////////
// WEBPACK FOOTER
// ./components/fx-calculator/fx-calculator.component.ts
// module id = 737
// module chunks = 0